import React from "react";
import { Routes, Route } from "react-router-dom";

// Public Pages
import LoginContainer from "../containers/LoginContainer";
import RegisterContainer from "../containers/RegisterContainer";

// Protected Pages
import DashboardContainer from "../containers/DashboardContainer";

import BuildingContainer from "../containers/BuildingContainer";
import CreateUpdateBuilding from "../pages/building/CreateUpdateBuilding";

import RentalPropertyContainer from "../containers/RentalPropertyContainer";
import CreateUpdateRentalProperty from "../pages/rental-property/CreateUpdateRentalProperty";

import TenantContainer from "../containers/TenantContainer";
import CreateUpdateTenant from "../pages/tenant/CreateUpdateTenant";

import InvoiceContainer from "../containers/InvoiceContainer";
import GenerateInvoice from "../pages/invoice/GenerateInvoice";

import ReportContainer from "../containers/ReportContainer";

import SettingContainer from "../containers/SettingContainer";
import Backup from "../pages/settings/backup/Backup";

import ProtectedRoute from "./ProtectedRoute";
import UserProfile from "../pages/profile/UserProfile";


const AppRoutes = () => {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={<LoginContainer />} />
      <Route path="/login" element={<LoginContainer />} />
      <Route path="/register" element={<RegisterContainer />} />

      {/* Protected Routes */}
      <Route path="/dashboard" element={<ProtectedRoute><DashboardContainer /></ProtectedRoute>} />

      <Route path="/building-list" element={<ProtectedRoute><BuildingContainer /></ProtectedRoute>} />
      <Route path="/building" element={<ProtectedRoute><CreateUpdateBuilding /></ProtectedRoute>} />
      <Route path="/building/:id" element={<ProtectedRoute><CreateUpdateBuilding /></ProtectedRoute>} />
      
      <Route path="/rental-property-list" element={<ProtectedRoute><RentalPropertyContainer /></ProtectedRoute>} />
      <Route path="/rental-property" element={<ProtectedRoute><CreateUpdateRentalProperty /></ProtectedRoute>} />
      <Route path="/rental-property/:id" element={<ProtectedRoute><CreateUpdateRentalProperty /></ProtectedRoute>} />
      
      <Route path="/tenant-list" element={<ProtectedRoute><TenantContainer /></ProtectedRoute>} />
      <Route path="/tenant" element={<ProtectedRoute><CreateUpdateTenant /></ProtectedRoute>} />
      <Route path="/tenant/:id" element={<ProtectedRoute><CreateUpdateTenant /></ProtectedRoute>} />
      
      <Route path="/invoice-list" element={<ProtectedRoute><InvoiceContainer /></ProtectedRoute>} />
      <Route path="/invoice" element={<ProtectedRoute><GenerateInvoice /></ProtectedRoute>} />
      <Route path="/invoice/:id" element={<ProtectedRoute><GenerateInvoice /></ProtectedRoute>} />
      
      <Route path="/reports" element={<ProtectedRoute><ReportContainer /></ProtectedRoute>} />
      
      <Route path="/backup" element={<ProtectedRoute><Backup /></ProtectedRoute>} />
      <Route path="/setting" element={<ProtectedRoute><SettingContainer /></ProtectedRoute>} />

      <Route path="/profile" element={<ProtectedRoute><UserProfile /></ProtectedRoute>} />
      
    </Routes>
  );
};

export default AppRoutes;
